import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Qualifier } from "../../internal/qualifier/Qualifier";
import { QualifierValue } from "../../internal/qualifier/QualifierValue";
import { Action } from "../../internal/Action";
/**
 * @description Changes the main background color to the one specified, as if a 'theme change' was applied (e.g. dark mode vs light mode).
 * @extends SDK.Action
 * @memberOf {Actions.Effect}
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var ThemeEffect = /*#__PURE__*/function (_Action) {
  _inherits(ThemeEffect, _Action);

  var _super = _createSuper(ThemeEffect);

  function ThemeEffect(color) {
    var _this;

    _classCallCheck(this, ThemeEffect);

    _this = _super.call(this);
    _this.effectName = 'theme';
    _this.color = color;
    return _this;
  }
  /**
   * @description The sensitivity to photographic elements of an image.
   *              A value of 0 treats the whole image as non-photographic.
   *              A value of 200 treats the whole image as photographic, so no theme change is applied.
   * @param {number} photosensitivity
   * @return {this}
   */


  _createClass(ThemeEffect, [{
    key: "photosensitivity",
    value: function photosensitivity(_photosensitivity) {
      this._photosensitivity = _photosensitivity;
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      var sensitivity = this._photosensitivity ? ":photosensitivity_".concat(this._photosensitivity) : ''; // Replace # in hex colors (#fff -> fff)

      var val = "".concat(this.effectName, ":color_").concat(this.color.replace('#', '')).concat(sensitivity);
      this.addQualifier(new Qualifier('e', new QualifierValue(val)));
      return;
    }
  }]);

  return ThemeEffect;
}(Action);

export { ThemeEffect };